import React from "react";
import { Box } from "@mui/material";
import RenderAppraisee from "../Appraisee/RenderAppraisee";
import RenderAppraiser from "./RenderAppraiser";
import RenderMeetingDate from "./RenderMeetingDate";
import RenderDate from "../../../Common/Date/RenderDate";

const AppraisalDetails = ({
    template,
    appraisee,
    appraiser,
    areaOfWork,
    meeting,
    isCompleted,
    isAppraiser = false,
    dueDate,
}) => {
    const displayJobRole = appraisee?.jobRole || "Not specified";
    const displayAreaOfWork = areaOfWork?.name || "Not specified";

    return (
        <Box className="flex-container">
            <dl className="row-data">
                <dt>Name</dt>
                <dd>
                    <RenderAppraisee
                        appraisee={appraisee}
                        isAppraiser={isAppraiser}
                    />
                </dd>
            </dl>

            <dl className="row-data">
                <dt>Job role</dt>
                <dd>{displayJobRole}</dd>
            </dl>

            <dl className="row-data">
                <dt>Area of work</dt>
                <dd>{displayAreaOfWork}</dd>
            </dl>

            <dl className="row-data">
                <dt>Appraiser</dt>
                <dd>
                    <RenderAppraiser
                        appraiser={appraiser}
                        isCompleted={isCompleted}
                    />
                </dd>
            </dl>
            <dl className="row-data">
                <dt>Meeting</dt>
                <dd>
                    <RenderMeetingDate
                        meeting={meeting}
                        isCompleted={isCompleted}
                    />
                </dd>
            </dl>
            <dl className="row-data">
                <dt>Due</dt>
                <dd>
                    <RenderDate date={dueDate} colourise={!isCompleted} />
                </dd>
            </dl>
            <dl className="row-data">
                <dt>Template</dt>
                <dd>{template}</dd>
            </dl>
        </Box>
    );
};

export default React.memo(AppraisalDetails);
